// extracted by mini-css-extract-plugin
module.exports = {"page":"transition-router-module--page--X4_DN"};